var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreviewUnavailable(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 109,
    height: 136,
    fill: "none",
    viewBox: "0 0 109 136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0ECE6",
    fillRule: "evenodd",
    d: "M69.027 0H5.6A5.6 5.6 0 000 5.6v124.8a5.6 5.6 0 005.6 5.6h96.8a5.6 5.6 0 005.6-5.6V38.973L69.027 0z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5951",
    d: "M77.782 75.594c-1.584-2.812-3.604-5.228-5.94-7.287l-3.327 3.406a21.83 21.83 0 015.148 6.217c.515.911.515 2.02 0 2.931a22.676 22.676 0 01-19.762 11.564c-1.703 0-3.406-.198-5.07-.594l-3.762 3.842a27.538 27.538 0 008.832 1.465c9.901 0 19.05-5.346 23.881-13.98 1.307-2.297 1.307-5.228 0-7.564z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5951",
    d: "M53.86 89.653c5.664 0 10.258-4.594 10.258-10.257 0-.99-.158-1.94-.396-2.812L51.247 89.336c.832.198 1.743.317 2.614.317zM74.143 56.397a2 2 0 00-2.828.033l-7.077 7.243a26.944 26.944 0 00-10.377-2.06c-9.9 0-19.05 5.347-23.88 13.981a7.787 7.787 0 000 7.564c1.821 3.248 4.276 6.02 7.128 8.238l-6.683 6.847a2 2 0 00.034 2.827l.546.533a2 2 0 002.827-.032L74.72 59.758a2 2 0 00-.033-2.83l-.544-.53zM34.1 80.861a2.974 2.974 0 010-2.93 22.676 22.676 0 0119.762-11.565 22.3 22.3 0 016.694 1.03L58.02 70.01a10.423 10.423 0 00-4.159-.871c-5.663 0-10.257 4.594-10.257 10.257 0 1.584.356 3.05.99 4.356l-4.158 4.238a22.903 22.903 0 01-6.337-7.129z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAF7F0",
    fillRule: "evenodd",
    d: "M69.03 0l39 39h-33.4a5.6 5.6 0 01-5.6-5.6V0z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewUnavailable);
export default __webpack_public_path__ + "static/media/previewUnavailable.38e8cf20d8fd6f3d158c9e3745440895.svg";
export { ForwardRef as ReactComponent };